import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/reducers';

export interface StartMissionState {
    confirmationDialogOpen: boolean;
    isAwaitingResponse: boolean;
}

const initialState: StartMissionState = {
    confirmationDialogOpen: false,
    isAwaitingResponse: false,
};

export const startMissionSlice = createSlice({
    name: 'startMission',
    initialState,
    reducers: {
        setConfirmationDialogOpen: (state: StartMissionState, action: PayloadAction<boolean>) => {
            state.confirmationDialogOpen = action.payload;
        },
        setIsAwaitingResponse: (state: StartMissionState, action: PayloadAction<boolean>) => {
            state.isAwaitingResponse = action.payload;
        },
    },
});

export const { setConfirmationDialogOpen, setIsAwaitingResponse } = startMissionSlice.actions;

export const getConfirmationDialogOpen = (state: RootState) => state.startMission.confirmationDialogOpen;
export const getIsAwaitingResponse = (state: RootState) => state.startMission.isAwaitingResponse;

export default startMissionSlice.reducer;
